module.exports = __webpack_public_path__ + "media/images/icons/phone-circle-d9023a80e3229d95c14aa7d02b6f2841.svg";